import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

function Empty() {
    return (
        <div className={classes.Empty}>
            <h5>
                <FormattedMessage id="AntiFraudList.empty" defaultMessage="Нет записей"/>
            </h5>
        </div>
    );
}

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/AntiFraudList/Empty.js